/* eslint-disable @typescript-eslint/no-unused-vars */
import classnames from 'classnames';
import React from 'react';
import TagsInput from 'react-tagsinput';
import { TagsInputProps } from 'types/dynamicInputs';
import Tooltip from 'components/common/tooltip';
import { InfoCircle } from 'iconsax-react';

const TagsInputComponent = ({
  value,
  onChange,
  onBlur,
  placeholder,
  label,
  labelTooltip,
  required,
  disabled,
  pristine,
  error,
  addKeys = [9, 13, 188],
  addOnBlur = true
}: TagsInputProps) => {
  const handleChange = (newTags: string[]) => {
    onChange(newTags);
    onBlur && onBlur();
  };

  return (
    <div className="tags-input">
      <div className={classnames('wrapper', { error: !pristine && error })}>
        {!!label && (
          <label className="label" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span>
              {label}
              {required ? ' *' : ''}
            </span>
            {labelTooltip ? (
              <Tooltip value={labelTooltip}>
                <span aria-label="help" style={{ display: 'inline-flex', alignItems: 'center' }}>
                  <InfoCircle size="16" color="#8b8b8b" />
                </span>
              </Tooltip>
            ) : null}
          </label>
        )}
        <TagsInput
          value={value}
          onChange={handleChange}
          inputProps={{ placeholder, disabled }}
          addKeys={addKeys}
          addOnBlur={addOnBlur}
        />
      </div>
      {!pristine && !!error && <span className="error-message body-2">{error}</span>}
    </div>
  );
};

export default TagsInputComponent;
